export default __webpack_public_path__ + "static/media/calender-thumb.e792e893.png";